import i18n from 'i18next';
import { initReactI18next, } from 'react-i18next';
import enTranslation from './translations/en/resource.json';
import esTranslation from './translations/es/resource.json';
import ptBRTranslation from './translations/pt-BR/resource.json';

const resources = {
  'pt-BR': {
    title: 'Português (Brasil)',
    translation: ptBRTranslation,
  },
  en: {
    title: 'English',
    translation: enTranslation,
  },
  es: {
    title: 'Español',
    translation: esTranslation,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'pt-BR',
  keySeparator: false,
  interpolation: { escapeValue: false },
  detection: {
    order: ['navigator', 'querystring', 'localStorage', 'cookie'],
    caches: ['localStorage']
  }
});

const lang = localStorage.getItem('lang');

if (lang) {
  i18n.changeLanguage(lang);
} else {
  localStorage.setItem('lang', i18n.language);
}

if (process.env.NODE_ENV === 'development') {
  window.i18next = i18n;
}

export default i18n;
